<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div class="lightbox">
      <div>
        <h1 name="days">Day Client Registration</h1>
        <p class="my-3">&nbsp;</p>
        <p class="formTitle">Quantity of Applications</p>
        <p>
          1 Day：<span class="red" name="TotalInvUsed_1"></span> /
          <span name="InvitationQuota_1"></span>
        </p>
        <p>
          4 Days：<span class="red" name="TotalInvUsed_4"></span> /
          <span name="InvitationQuota_4"></span>
        </p>
        <p class="my-3">&nbsp;</p>
        <form id="form" @submit.prevent="submitInvitation">
          <!-- hidden -->
          <input type="hidden" name="RegNo" />
          <input type="hidden" name="Type" />
          <input type="hidden" name="Lang" value="tw" />
          <!-- hidden end -->
          <p class="formTitle">Language <span class="red">*</span></p>
          <label
            ><input
              type="radio"
              name="eLang"
              value="tw"
              class="largeItem"
              v-model="E_Lang"
              checked
            />
            Chinese</label
          >
          &nbsp;
          <label
            ><input
              type="radio"
              name="eLang"
              value="en"
              class="largeItem ml-2"
              v-model="E_Lang"
            />
            English</label
          >
          <p class="my-3">&nbsp;</p>
          <p class="formTitle">Email <span class="red">*</span></p>
          <input
            type="email"
            name="ClientEmail"
            class="textStyle maxText"
            maxlength="50"
            v-model="ClientEmail"
            placeholder="Email Address Here"
            required
          />
          <p class="my-3">&nbsp;</p>
          <p class="align_c">
            <input type="submit" value="Send" class="btnStyle" />
          </p>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  data() {
    return {
      CSRF_Token: "",
      RegNo: "",
      Type: "",
      E_Lang: "en",
      ClientEmail: "",
      lang: "en",
      hasAccountId: true,
      MenuInvitation: [],
    };
  },

  methods: {
    InviteLink(Url) {
      const vm = this;
      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/${Url}?no=${vm.RegNo}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/${Url}?no=${vm.RegNo}`;
      }
    },
    closefancybox() {
      parent.$.fancybox.close();
    },

    submitInvitation() {
      const vm = this;

      const url = "/apiExhibitors/ClientInvitation/";

      const info = {
        RegNo: vm.RegNo,
        Type: vm.Type,
        E_Lang: vm.E_Lang,
        ClientEmail: vm.ClientEmail,
        CSRF: vm.CSRF_Token,
      };

      // console.log(info)

      if (vm.lang == "tw") {
        if (!vm.ClientEmail) {
          alert("輸入欄位不完整，請重新檢查！");
        } else {
          axios.post(url, info).then(function (response) {
            if (response.data.Code == 200) {
              alert(`代理申請信已寄至您填寫的信箱 \n ${vm.ClientEmail}`);
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 251 || response.data.Code == 500) {
              alert("您輸入的Email有誤！");
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`;
            } else if (response.data.Code == 253) {
              alert("您輸入的Email有誤！");
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 254) {
              alert("您填入的Email已有參觀資格！");
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 255) {
              alert("超過代理登錄額度！");
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 256) {
              alert("您已過代理申請時間！");
              vm.closefancybox();
              parent.window.location.reload();
            }
          });
        }
      } else {
        if (!vm.ClientEmail) {
          alert("There are incomplete fields, please check again.");
        } else {
          axios.post(url, info).then(function (response) {
            if (response.data.Code == 200) {
              alert(
                `Client registration has been sent to your email! \n ${vm.ClientEmail}`
              );
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 251 || response.data.Code == 500) {
              alert("Invalid email, please check again.");
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`;
            } else if (response.data.Code == 253) {
              alert("Invalid email, please check again.");
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 254) {
              alert("The email you entered already have admission.");
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 255) {
              alert("You have reached the limited amount quota!");
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 256) {
              alert("Client registration is closed! ");
              vm.closefancybox();
              parent.window.location.reload();
            }
          });
        }
      }
    },
  },

  created() {
    const vm = this;

    //取得語系

    let lang = "en";

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1].split("&")[0];
    vm.Type = currentUrl.split("d=")[1];

    //判斷是否有AccountID
    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`)
      .then((response) => {
        // console.log(response.data.Data)

        let AccountID = response.data.Data.AccountID;

        if (!AccountID) {
          vm.hasAccountId = false;

          $.getJSON(
            "/apiExhibitors/ExpoContact/" + vm.RegNo + "?lang=" + lang,
            function (data) {
              $('[name="ExpoContact"]').html(data.Data.ExpoContact);
            }
          );
        } else {
          vm.hasAccountId = true;
        }
      });

    //取得邀請選單
    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/MenuInvitation/${vm.RegNo}?lang=${vm.lang}`
      )
      .then((response) => {
        // console.log(response.data)

        vm.MenuInvitation = response.data.Data;
      });

    $.getJSON(
      "/apiExhibitors/Exhibition/" + vm.RegNo,
      { lang: lang },
      function (data) {
        $('[name="ExhEnd"]').text(data.Data.ExhEnd);

        //當前時間 Timestamp
        var currentdate = Date.parse(new Date()).valueOf();

        //設定畢展時間 Timestamp
        var CloseDay = new Date(data.Data.ExhEnd);
        CloseDay.setDate(CloseDay.getDate());
        //6點前關閉
        var ExhTime = Date.parse(CloseDay) + 64800000;

        if (currentdate > ExhTime) {
          if (lang == "tw") {
            $(".btnStyle").addClass("btnExpire");
          } else {
            $(".btnStyle").addClass("ebtnExpire");
          }
        }
      }
    );

    //InvTotal
    $.getJSON("/apiExhibitors/InvTotal_Quota/" + vm.RegNo, function (data) {
      //InvTotal
      $('[name="InvitationQuota_1"]').text(data.Data.InvitationQuota_1);
      $('[name="InvitationQuota_4"]').text(data.Data.InvitationQuota_4);
      $('[name="TotalInvUsed_1"]').text(data.Data.TotalInvUsed_1);
      $('[name="TotalInvUsed_4"]').text(data.Data.TotalInvUsed_4);

      $('[name="TotalMember_1"]').text(data.Data.TotalMember_1);
      $('[name="TotalMember_4"]').text(data.Data.TotalMember_4);
      $('[name="TotalVisitor_1"]').text(data.Data.TotalVisitor_1);
      $('[name="TotalVisitor_4"]').text(data.Data.TotalVisitor_4);

      //判斷是否額滿
      if (data.Data.InvitationQuota_1 == data.Data.TotalInvUsed_1) {
        if (lang == "tw") {
          $('[name="btnOneDay"]').addClass("btnFull");
        } else {
          $('[name="btnOneDay"]').addClass("ebtnFull");
        }
      }
      if (data.Data.InvitationQuota_4 == data.Data.TotalInvUsed_4) {
        if (lang == "tw") {
          $('[name="btnFourDay"]').addClass("btnFull");
        } else {
          $('[name="btnFourDay"]').addClass("ebtnFull");
        }
      }
    });
  },
};
</script>

<style lang="scss"></style>
